import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreditCardPipe } from './credit-card.pipe';
import { CustomNumberPipe } from './custom-number.pipe';



@NgModule({
  declarations: [
    CreditCardPipe,
    CustomNumberPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CreditCardPipe,
    CustomNumberPipe
  ]
})
export class PipesModule { }
